// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2NK0Y","rightAdornment":"Header_rightAdornment__1Hx9B"};